import emptySliceApi from '../../../shared/store/emptyApiSlice';

export interface AddToCartItem {
  qty: number;
  sku: string;
  dealCode: string;
  price: number;
  bundleOptions: {
    optionId: number;
    selectionId: number;
  }[];
}

export interface CartItemResponse {
  cartId: string;
  itemId: number;
  productType: string;
  qty: number;
  sku: string;
}

export interface AddToCartDetails {
  accountId: string;
  items: AddToCartItem[];
}

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    addToCart: builder.mutation<{ items: AddToCartItem[] }, AddToCartDetails>({
      query: ({ accountId, items }) => ({
        url: `/cart/items?accountNumber=${accountId}`,
        method: 'POST',
        body: { items },
      }),
      invalidatesTags: (result, error) => {
        if (error) {
          return [];
        }
        return ['Product', 'CartProducts'];
      },
    }),
  }),
  overrideExisting: true,
});

export const { useAddToCartMutation } = apiSlice;
